// removes credit apps from local storage if they are expired
function expireCreditAppDeals(paymentsInfo) {
  if (paymentsInfo?.creditAppDeals?.length > 0) {
    const now = new Date().getTime();
    paymentsInfo.creditAppDeals = [...paymentsInfo.creditAppDeals.filter(creditApp => now < creditApp.expiry)];
  }
}
export { expireCreditAppDeals as default };
